export default "__VITE_ASSET__DSltPcHS__"